var map = {
	"./poke-1.png": 978,
	"./poke-10.png": 186,
	"./poke-11.png": 904,
	"./poke-12.png": 496,
	"./poke-13.png": 721,
	"./poke-2.png": 841,
	"./poke-3.png": 805,
	"./poke-4.png": 278,
	"./poke-5.png": 266,
	"./poke-6.png": 105,
	"./poke-7.png": 261,
	"./poke-8.png": 364,
	"./poke-9.png": 310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;